import React from "react";
// import PricingHeader from "../components/PricingHeader";
import PricingPlans from "../components/PricingPlans";
// import TestimonialGrid from "../components/TestimonialGrid";
// import FAQPricing from "../components/FAQPricing";
// import { SUBSCRIPTION_HEADING } from '../constants/SubscriptionSteps';
// import SUBSCRIPTION_STEPS from '../constants/SubscriptionSteps';
// import NeonEffectsSteps from "../components/NeonEffectsSteps";

const PricingPage = () => {
  return (
    <div>
      <PricingPlans />
      {/* <TestimonialGrid /> */}
       {/* <NeonEffectsSteps steps={SUBSCRIPTION_STEPS} heading={SUBSCRIPTION_HEADING} /> */}
      {/* <FAQPricing /> */}
    </div>
  );
};

export default PricingPage;
